export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAll: state => state.items,
    getByStatus: state => status => state.items.filter(item => item.status_id == status || item.status.id == status),
    getByStatusSlug: state => status => state.items.filter(item => item.status_slug == status || item.status.status_slug == status),
    getItem: state => id => state.items.find(item => item.id == id),
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'transfer',
        api_data_path: 'transfers',
        namespace: 'transfer'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items d'un (ou plusieurs) statut via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   array   status  Status
     * @param   boolean wait    Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise         Aucune donnée n'est retournée
     */
    getByStatusSlug: (context, status, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'transfer/by/status',
        api_data_path: 'transfers',
        namespace: 'transfer',
        query: 'status=' + status.join('|')
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'transfer/index/simple',
        api_data_path: 'transfers',
        namespace: 'transfer'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'transfer',
        namespace: 'transfer',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'transfer',
        namespace: 'transfer',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'transfer',
        namespace: 'transfer',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'transfer',
        namespace: 'transfer',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/transfer.js